import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import BtnExcel from '../../Components/BtnExcel';
import dayjs from 'dayjs';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Select,
    Input,
} from 'antd';
import { 
  formatAmount, 
  getTodayDateISO, 
  formatDate,
  getStartDate, 
  getEndDate, 
  getStatus, 
} from '../../Utils/Common';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;
const { Search } = Input;
const { confirm } = Modal;

const ParkingExpense = () => {
  const start_date = getStartDate();
  const end_date = getEndDate();
  const asynch_status = getStatus();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [excelData, setExcelData] = useState([]);
  const [total, setTotal] = useState('');
  const startDate = dayjs().startOf('month');
  const endDate = dayjs().endOf('month');
  const [expenseData, setExpenseData] = useState([]);

  const [filterConfig, setFilterConfig] = useState({
    search: '',
    type: asynch_status ? asynch_status :'',
    expense_id: '',
    start_date: start_date ? start_date : dayjs(startDate).format('YYYY-MM-DD'),
    end_date: end_date ? end_date : dayjs(endDate).format('YYYY-MM-DD'),
    page: 1,
  });

  const { callPost, loading } = usePostRequest(()=>{
    fetchAllExpense();
  });

  function ActionBtn(row) {
    const items = [
      {
        label: (
          <div onClick={() => navigate('/manage-expense/parking/edit/' + row.row.id)}>
            {row.row.status === "completed" ? 'View' : 'Edit'}
          </div>
        ),
        key: 'edit',
      },
      {
        label: (
          <div onClick={() => navigate('/expense/preview/parking/' + row.row.id)}>
            Preview Expense
          </div>
        ),
        key: 'preview',
      },
      (row.row.status === "pending") && {
        label: (
          <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
            Delete
          </div>
        ),
        key: 'delete',
      },
    ];

    return (
      <span className='center'>
        <Dropdown
          menu={{
          items,
          }}
          trigger={['click']}
        >
          <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
            <Space>
              <MoreVert />
            </Space>
          </div>
        </Dropdown>
      </span>
    );
  };

  async function fetchAllExpense() {
    setIsLoading(true)
    const response = await UseGetRequest("parking_expenses/get", filterConfig);
    if (response?.data) {
      setTotal(response?.data?.total ? response?.data?.total : 0)
      const data = response?.data?.data?.map((info) => ({
        id: parseInt(info.id),
        supplier_id: info.supplier_id,
        tenant_id: info.tenant_id,
        rental_unit_id: info.rental_unit_id,
        owner_id: info.owner_id,
        trade_name: info.trade_name,
        type: info.type,
        expense_date: formatDate(info.expense_date),
        date_covered: formatDate(info.date_covered),
        main_usage: info.main_usage,
        sub_usage: info.sub_usage,
        remarks: info.remarks,
        description: info.description,
        total: formatAmount(info.total),
        paid_amount: formatAmount(info.paid_amount),
        status: info.status,
        supplier_name: info.supplier_name,
        property_name: info.property_name,
        concatenated_property: info.concatenated_property,
      }))
      setExpenseData(data);
      setPageSize(response?.data?.size)
    } else {
      setExpenseData([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true)
    const response = await UseGetRequest("parking_expenses/get", 
      {
        search: filterConfig.search,
        type: filterConfig.type,
        expense_id: filterConfig.expense_id,
        start_date: filterConfig.start_date,
        end_date: filterConfig.end_date,
      }
    );
    if (response?.data) {
      const excel_data = response.data.data.map((data) => ({
        id: data.id,
        supplier_name: data.supplier_name,
        trade_name: data.trade_name,
        type: data.type,
        property_name: data.property_name,
        expense_date: data.expense_date && formatDate(data.expense_date),
        date_covered: data.date_covered && formatDate(data.date_covered),
        total: data.total && formatAmount(data.total),
        paid_amount: data.paid_amount && formatAmount(data.paid_amount),
        status: data.status,
        description: data.description,
        remarks: data.remarks,
      }))

      setExcelData(excel_data)
      setExportLoading(false)
    } else {
      setExpenseData([])
      setExportLoading(false)
    }
  }

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this expense?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      confirmLoading: loading,
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      onOk() {
        callPost(
          "parking_expenses/delete", 
          {parking_expense_id: id},
          false
        );
      },
    });
  };

  const onSearchDate = (e) => {
    if(e){
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: e[0].format("YYYY-MM-DD"),
          end_date: e[1].format("YYYY-MM-DD"),
          page: 1,
        }
      ));
      localStorage.setItem('start_date', JSON.stringify(e[0].format("YYYY-MM-DD")));
      localStorage.setItem('end_date', JSON.stringify(e[1].format("YYYY-MM-DD")));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: '',
          end_date: '',
          page: 1,
        }
      ));
      localStorage.removeItem('start_date');
      localStorage.removeItem('end_date');
    }
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onSearchType = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        type: e || '',
        page: 1,
      }
    ));
    if(e){
      localStorage.setItem('status', JSON.stringify(e));
    } else {
      localStorage.removeItem('status');
    }
  }; 

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchAllExpense();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'parking_expenses_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={9} className='header-container'>
              PARKING EXPENSE
          </Col>
          <Col span={15} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Supplier Name",
                  "Trade Name",
                  "Type",
                  "Property",
                  "Expense Data",
                  "Date Covered",
                  "Total",
                  "Paid Amount",
                  "Status",
                  "Description",
                  "Remarks",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Expense_${getTodayDateISO()}.xlsx`}
              />
              <Button 
                className='button-color responsive-header-btn' 
                onClick={() => navigate('/manage-expense/parking/add')}  
                type="primary"
              >
                + Add Expense
              </Button>
            </Space>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Space className='responsive-inline excel-row'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />   
              <RangePicker 
                renderExtraFooter={() => 'extra footer'}
                className='responsive-header-input'
                onChange={(e)=>onSearchDate(e)}
                value={[
                  filterConfig?.start_date ? dayjs(filterConfig.start_date) : null,
                  filterConfig?.end_date ? dayjs(filterConfig.end_date) : null
                ]}
              />
              <Select
                placeholder="All Type"
                onChange={(e)=>onSearchType(e)}
                placement='bottomLeft'
                value={filterConfig.type}
                // style={{width:'14vw'}}
                className='select-field responsive-header-input'
                align='left'
                options={[
                  {
                    value: '',
                    label: 'All Type',
                  },
                  {
                    value: 'owner',
                    label: 'Owner',
                  },
                  {
                    value: 'tenant',
                    label: 'Tenant',
                  },
                  {
                    value: 'internal',
                    label: 'Internal',
                  },
                ]}
              />     
            </Space>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='amount-total pe-4' align='right'>
            Total Expense: {formatAmount(total)}
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <AntDTable
              tableHeaders={[
              "Doc No.",
              "Supplier",
              "Expense Date",
              "Type",
              "Name",
              "Building & Unit Number",
              "Description",
              "Total",
              "Status",
              ]}
              headerSelector={[
              "id",
              "supplier_name",
              "expense_date",
              "type",
              "trade_name",
              "concatenated_property",
              "description",
              "total",
              "status",
              ]}
              tableData={expenseData}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              loading={isLoading}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={pageSize}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default ParkingExpense
